export const formatLicenseId = (input: string): string => {
  const regex = /([a-zA-Z]+|[0-9]+)/g
  const matches = input.match(regex)
  if (matches) {
    return matches.join('-')
  }
  return input
}
